import React from 'react'
import {PRICE_TIER_COMPARISON, PRICE_TIERS} from '../core/_const'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {useIntl} from 'react-intl'
import {ROUTES} from '../../../../_gori/constants'
import clsx from 'clsx'

type Props = {
  page: string
  onClick?: any
}

const ComparePlanFeatures: React.FC<Props> = ({page, onClick}) => {
  const intl = useIntl()
  const BASE_DOMAIN = process.env.REACT_APP_DOMAIN
  const registrationURL = document.location.protocol + '//' + BASE_DOMAIN + ROUTES.AUTH.REGISTRATION

  // Shared "unlimited" cell: text on ≥601px, infinity icon on ≤600px (SCSS toggles visibility)
  const unlimitedCell = (
    <>
      <p className='unlimited-text text-primary darker-primary fs-2 lh-md fw-boldest mb-0'>
        {intl.formatMessage({id: 'UNLIMITED'})}
      </p>
      <img
        className='unlimited-icon'
        src={toAbsoluteUrl('/media/gori/landing/infinity.svg')}
        alt={intl.formatMessage({id: 'UNLIMITED'})}
      />
    </>
  )

  return (
    <section
      className={clsx('tier-comparison', {
        container: page === 'pricing',
      })}
    >
      <div className='accordion open accordion__wrapper' id='pricingTiersAccordion'>
        <div className='accordion-item'>
          <h4 className='accordion-header' id='headingId'>
            <button
              className={clsx('roboto accordion-button', {
                collapsed: page !== 'pricing',
                'fw-boldest justify-content-center': page === 'pricing',
                'fw-bolder justify-content-start': page !== 'pricing',
              })}
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#collapseId'
              aria-expanded='true'
              aria-controls='collapseId'
            >
              {intl.formatMessage({id: 'TIER_COMPARISON_HEADING'})}
            </button>
          </h4>
          <div
            id='collapseId'
            className={clsx('accordion-collapse collapse', {
              show: page === 'pricing',
            })}
            aria-labelledby='headingId'
            data-bs-parent='#pricingTiersAccordion'
          >
            <div className='accordion-body pt-0'>
              <ul className='price-comparison-list list-unstyled'>
                <li className='header-row px-3 pb-3 pt-8'>
                  <div></div>
                  {PRICE_TIERS.map((tier, index) => (
                    <div
                      key={tier.tier_name + index}
                      className='d-flex p-3 flex-column justify-content-center align-items-center '
                    >
                      <h5 className='fw-bold lh-lg mb-0'>
                        {intl.formatMessage({id: tier.tier_name})}
                      </h5>
                      {!tier.negotiable && (
                        <p className='pricing roboto fw-bolder text-center mb-3'>
                          ${tier.price}
                          <small className='text-body-secondary'>/mo</small>
                        </p>
                      )}
                      {page === 'pricing' && (
                        <a
                          href={tier.negotiable ? 'https://gori.ai/contact/' : registrationURL}
                          {...(tier.negotiable && {target: '_blank', rel: 'noreferrer noopener'})}
                          className='tier-cta-btn btn btn-advanced-primary btn-darker pretendard fw-boldest fs-4 fs-lg-2 lh-lg rounded-pill mt-auto mb-4'
                        >
                          {intl.formatMessage({
                            id: tier.negotiable ? 'LINK_TO_SALES_LABEL' : 'GET_STARTED',
                          })}
                        </a>
                      )}
                    </div>
                  ))}
                </li>

                {PRICE_TIER_COMPARISON.map((feature, index) => (
                  <li key={feature.name + index} className='p-3'>
                    <div>
                      <h5 className='fs-3 lh-lg fw-boldest mb-0'>
                        {intl.formatMessage({id: feature.name})}
                      </h5>
                    </div>

                    {/* Free Plan */}
                    <div className='d-flex text-center justify-content-center align-items-center'>
                      {feature.lowest_tier_available === 1 && (
                        <>
                          {!feature.unlimited && (
                            <img
                              src={toAbsoluteUrl('/media/gori/landing/teal-check.svg')}
                              alt='check'
                            />
                          )}

                          {feature.unlimited && unlimitedCell}
                        </>
                      )}
                    </div>

                    {/* Interprise Plan */}
                    <div className='d-flex text-center justify-content-center align-items-center'>
                      {feature.lowest_tier_available <= 2 && (
                        <>
                          {feature.unlimited && unlimitedCell}

                          {!feature.unlimited && (
                            <img
                              src={toAbsoluteUrl('/media/gori/landing/teal-check.svg')}
                              alt='check'
                            />
                          )}
                        </>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export {ComparePlanFeatures}
